import React from 'react';
import { IoIosArrowRoundBack, IoIosArrowRoundForward } from 'react-icons/io';

import moment from 'moment';

import AppBar from 'components/AppBar';
import useStoreTranslation from 'hooks/useStoreTranslation';
import { FlightStretch } from 'models/flightSearch';
import { MultidestinationTrip } from 'models/multiDestinationTrip';

import { TravelContainer, TravelInfo, ArrowsContainer, DateInfo } from './styles';

interface InfoProps {
  flightStretch: FlightStretch;
  multiDestinationTrips?: MultidestinationTrip[];
  departurePoint?: string;
  arrivalPoint?: string;
  departureDate?: Date;
  returnDate?: Date;
  isOneWay: boolean;
}

interface Props {
  info: InfoProps;
  loading: boolean;
  goBack: () => void;
  onEdit: () => void;
}

const FlightsListHeader = ({ info, loading, goBack, onEdit }: Props) => {
  const { t } = useStoreTranslation();
  return (
    <AppBar goBack={goBack} loading={loading} rightLabel={t('flightsList.edit')} rightAction={onEdit}>
      <TravelContainer>
        <TravelInfo>
          {info.flightStretch !== FlightStretch.MULTIDESTINATION
            ? info.departurePoint
            : t('flightsSearch.type.multiDestination')}
        </TravelInfo>
        {info.flightStretch !== FlightStretch.MULTIDESTINATION && (
          <ArrowsContainer>
            <IoIosArrowRoundForward size={15} />
            {!info.isOneWay && <IoIosArrowRoundBack size={15} />}
          </ArrowsContainer>
        )}
        <TravelInfo>{info.arrivalPoint}</TravelInfo>
      </TravelContainer>
      <DateInfo>
        {moment(info.departureDate).format('ddd DD, MMM')}
        {`${info.returnDate ? ` - ${moment(info.returnDate).format('ddd DD, MMM')}` : ''}`}
      </DateInfo>
    </AppBar>
  );
};

export default FlightsListHeader;
